// extracted by mini-css-extract-plugin
module.exports = {"header-font":"NC3mvVZYDXBOSJOwYGa4r","description-font":"_2LSK5VW7JHzDO3IHWzNrO0","sad-icon":"_1rW5utspjgv0TZvIZRVigN"};